import { Component, Input, OnInit, OnDestroy, HostListener, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileEditModalComponent } from '../../../modals/profile-edit-modal/profile-edit-modal.component';

import { UserService } from '../../../services/user.service';

import * as Classes from '../../../classes/models.classes';


interface MenuItem {
    icon: string;
    label: string;
    link: string;
}

@Component({
    selector: 'app-profile-menu-page-top',
    templateUrl: './profile_menu_page_top.component.html',
    styleUrls: ['./profile_menu_page_top.component.css'] 
})
export class ProfileMenuPageTopComponent implements OnInit, OnDestroy, AfterViewInit  {
    @Input() UserID: number;
    @Input() Username: string;  
    @Input() ProfileUserID: number;
    @Input() ProfileUsername: string;
    @Input() ProfileName: string;  
    @Input() ProfileUserImg: string;
    @Input() ProfileBannerImage: string;
    @Input() ProfileImageDirectory: string;
    //@Input() isFollowed: boolean; 
    @ViewChild('profileLink', { static: false }) profileLinkElement: ElementRef;


    menuItems: MenuItem[];  // Array to hold menu items

    userProfileStates = new Map<number, any>();

    showProfileBox: boolean = false;
    showTooltip: boolean = false;

    isFollowed: boolean = false; // Follow status will be fetched dynamically

    userProfileVisible = false;
    hoverBoxStyle = {};
    userProfile: Classes.ProfileModel = new Classes.ProfileModel();

    BannerImageUrl: string;

    private unsubscribeHover$ = new Subject<void>();

    private observer: IntersectionObserver;
    hoverTimer: any; // To hold the timer reference
    private timeoutId: any; // Holds the reference to the timeout



    constructor(
        private userService: UserService,
        private modalService: NgbModal

    ) {
        // Define menu items - this could instead be loaded from a service
        this.menuItems = [
            { icon: 'fa-house', label: 'Home', link: '/' },
            { icon: 'fa-compass', label: 'Explore', link: '/explore' },
            { icon: 'fa-bell', label: 'Notifications', link: '/notifications' },
            // Add more items as needed
        ];
    }

    ngOnInit(): void {
        //console.log('Profile Menu Top Init - this.ProfileUserID:', this.ProfileUserID);

        // Additional initialization can be done here
        this.BannerImageUrl = "/img_profile/" + this.ProfileUserID + "/" + this.ProfileBannerImage;
        //console.log('Updated UserImg:', this.UserImg);
        this.fetchFollowStatus();
        this.loadUserProfileData(false);
        //console.log('userProfile:', this.userProfile);


    }

    ngAfterViewInit(): void {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.loadUserProfileData(false);
                }
            });
        });

        if (this.profileLinkElement) {
            this.observer.observe(this.profileLinkElement.nativeElement);
        }
    }

    ngOnDestroy(): void {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId); // Clear timeout on component destruction
        }
        if (this.hoverTimer) {
            clearTimeout(this.hoverTimer); // Clear the timer if the mouse leaves the link
        }
        this.showProfileBox = false;
        this.showTooltip = false;
        // Clear the timeoutId after it executes
        this.timeoutId = null;
        this.hoverTimer = null;
        if (this.observer && this.profileLinkElement) {
            this.observer.unobserve(this.profileLinkElement.nativeElement);
        }
    }

    @HostListener('window:scroll', ['$event'])
    onScroll(): void {
        this.showProfileBox = false;
        this.showTooltip = false;
        // Clear the timeoutId after it executes
        this.timeoutId = null;
        this.hoverTimer = null;
    }

    showTimeDetailHover(event: MouseEvent) {
        //console.log(`Mouse over loadUserProfile`);

        event.stopPropagation(); // Add this to prevent event bubbling

        // Check the class of the event target to determine which functionality to trigger
        const target = event.target as HTMLElement;
        if (target.classList.contains('publish-date')) {
            // Logic for showing the date tooltip
            this.hoverTimer = setTimeout(() => {
                this.showTooltip = true;

                if (this.hoverTimer) clearTimeout(this.hoverTimer);

                this.showProfileBox = false;
            }, 1000);  // Delay in milliseconds
        } 
    }

    loadUserProfile(event: MouseEvent) {
        //console.log(`Mouse over loadUserProfile`);

        event.stopPropagation(); // Add this to prevent event bubbling

        // Check the class of the event target to determine which functionality to trigger
        const target = event.target as HTMLElement;
        if (target.classList.contains('publish-date')) {
            // Logic for showing the date tooltip
            this.hoverTimer = setTimeout(() => {
                this.showTooltip = true;

                if (this.hoverTimer) clearTimeout(this.hoverTimer);

                this.showProfileBox = false;
            }, 2000);  // Delay in milliseconds
        } else {
            this.hoverTimer = setTimeout(() => {

                this.loadUserProfileData(true);

            }, 2000); // Delay of 1000 milliseconds (1 second)
        }
    }

    loadUserProfileData(showBox: boolean = false) {
        this.userService.getUserProfile(this.ProfileUsername).subscribe(data => {
            this.userProfile = data;
            if (showBox) {
                this.adjustHoverBoxPosition();
                this.showProfileBox = true;
            }
        });
    }

    keepHoverBoxVisible(): void {
        //this.unsubscribeHover$.next();
        if (this.timeoutId) {
            clearTimeout(this.timeoutId); // Cancel the pending timeout
            this.timeoutId = null;
        }
        this.showProfileBox = true;
    }

    hideUserProfile() {
        if (this.timeoutId) clearTimeout(this.timeoutId);
        if (this.hoverTimer) clearTimeout(this.hoverTimer);

        // Set a new timeout
        this.timeoutId = setTimeout(() => {
            //clearTimeout(this.hoverTimer); // Clear the timer if the mouse leaves the link
            this.showProfileBox = false;
            this.showTooltip = false;
            // Clear the timeoutId after it executes
            this.timeoutId = null;
        }, 2000); // Delay in milliseconds
    }

    adjustHoverBoxPosition(): void {
        if (this.profileLinkElement && this.profileLinkElement.nativeElement) {
            const rect = this.profileLinkElement.nativeElement.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const hoverBoxHeight = 200;  // Fixed height or dynamically determined

            if (spaceBelow < hoverBoxHeight) {
                this.hoverBoxStyle = { bottom: '30px' };
            } else {
                this.hoverBoxStyle = { top: '30px' };
            }
        }
    }

    fetchFollowStatus() {
        this.userService.getFollowStatus(this.UserID, this.ProfileUserID).subscribe({
            next: (result) => {
                this.isFollowed = result.isFollowed;
            },
            error: (error) => {
                console.error('Error fetching follow status:', error);
            }
        });
    }

    followUser() {
        this.userService.followUser(this.UserID, this.ProfileUserID, this.isFollowed, false, false).subscribe({
            next: (result) => {
                console.log('User followed successfully');
            },
            error: (error) => {
                console.error('Error following the user', error);
            }
        });
    }

    formatUrl(url: string): string {
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            return 'https://' + url; // Prepend https:// if the scheme is missing
        }
        return url; // Return the original URL if it already has a scheme
    }

    openEditProfileModal(): void {
        const modalRef = this.modalService.open(ProfileEditModalComponent, {
            size: 'lg',
            backdrop: 'static', // Prevent close on outside click
            beforeDismiss: () => false, // Prevent default close
        });

        // Pass input variables to the modal
        modalRef.componentInstance.UserID = this.UserID;
        modalRef.componentInstance.profileUserId = this.ProfileUserID;
        modalRef.componentInstance.ProfileName = this.ProfileName;
        modalRef.componentInstance.Username = this.ProfileUsername;
        modalRef.componentInstance.UserImg = this.ProfileUserImg;
        modalRef.componentInstance.BannerImage = this.ProfileBannerImage;
        modalRef.componentInstance.ImageDirectory = this.ProfileImageDirectory;

        // Handle modal close events if needed
        modalRef.result
            .then((result) => {
                if (result) {
                    // Update the displayed images with new image names
                    this.ProfileUserImg = result.UserImg;
                    this.ProfileBannerImage = result.BannerImage;

                    this.BannerImageUrl = "/img_profile/" + this.ProfileUserID + "/" + this.ProfileBannerImage;
                    this.loadUserProfileData(false);

                //    console.log('Updated images:', result);
                }
            //    console.log('Modal closed with result:', result);
            })
            .catch((dismissReason) => {
                console.log('Modal dismissed with reason:', dismissReason);
            });
    }
}
